import { render, staticRenderFns } from "./SampleProjectsView.vue?vue&type=template&id=3af043e3&scoped=true&"
import script from "./SampleProjectsView.vue?vue&type=script&lang=js&"
export * from "./SampleProjectsView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all.css?vue&type=style&index=0&id=3af043e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af043e3",
  null
  
)

export default component.exports